import React, { useState } from "react";
import Arrow from "../assets/Arrow.svg";
import ArrowDown from "../assets/ArrowDown.svg";
import styles from "./Select.module.scss";

export const Select = ({
  label,
  placeholder = "Выберите значение",
  options = [],
  value,
  onChange,
  disabled = false,
  error = "",
  variant = "primary",
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const selectedOption = options.find((option) => option.value === value);

  const handleSelect = (option) => {
    onChange?.(option.value);
    setIsOpen(false);
  };

  return (
    <div
      className={[
        styles.select,
        styles[`select_${variant}`],
        disabled ? styles.select__disabled : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <button
        type="button"
        className={[
          styles.select__control,
          isOpen ? styles.select__controlOpen : "",
          error ? styles.select__controlError : "",
          styles[`select__control_${variant}`],
        ]
          .filter(Boolean)
          .join(" ")}
        onClick={() => !disabled && setIsOpen((prev) => !prev)}
        disabled={disabled}
      >
        {label && (
          <div className={styles.select__label}>
            <span>{label}</span>
            <span>
              <img src={isOpen ? Arrow : ArrowDown} />
            </span>
          </div>
        )}
        <div className={styles.select__selectedOptionBlock}>
          <span
            className={
              selectedOption
                ? styles[`select__value_${variant}`]
                : styles.select__placeholder
            }
          >
            {selectedOption ? `${selectedOption.label}` : placeholder}
          </span>
          {!label && (
            <span>
              <img src={isOpen ? Arrow : ArrowDown} />
            </span>
          )}
        </div>
      </button>
      {isOpen && !disabled && (
        <div
          className={[
            styles.select__dropdown,
            styles[`select__dropdown_${variant}`],
          ]
            .filter(Boolean)
            .join(" ")}
        >
          {options.length > 0 ? (
            options.map((option) => (
              <button
                key={option.value}
                type="button"
                className={[
                  styles.select__option,
                  option.value === value ? styles.select__optionActive : "",
                  styles[`select__option_${variant}`],
                ]
                  .filter(Boolean)
                  .join(" ")}
                onClick={() => handleSelect(option)}
              >
                {option.dropdownLabel}
              </button>
            ))
          ) : (
            <div className={styles.select__empty}>Нет вариантов</div>
          )}
        </div>
      )}
      {error && <div className={styles.select__error}>{error}</div>}
    </div>
  );
};
